import JSX, { h } from 'preact'
import Icon from '../assets'
import { Item } from './Item'

interface Props {
  loading: boolean,
  items: Array<Item>,
  getMenuProps: Function,
  getItemProps: Function,
  highlightedIndex: number,
  children: JSX.Element
}

const ItemList = ({
  loading,
  items,
  getMenuProps,
  getItemProps,
  highlightedIndex,
  children
} : Props) => {
  return loading
    ? <div class='control-dropdown'>
      <div class='control-dropdown__list'>
        <div class='loader'>
          <Icon icon='loader' />
        </div>
      </div>
    </div>
    : items.length ? <div class='control-dropdown'>
      <div {...getMenuProps({ class: 'control-dropdown__list' })}>
        {items.map((item, index) =>
          <a {...getItemProps({
            index,
            item: items[index],
            class: `selector-item ${highlightedIndex === index ? 'active' : ''} qa-selector-item`
          })}
          >
            {children[0](item)}
          </a>
        )}
      </div>
    </div>
      : null
}
export default ItemList
